import React from "react";
import { useHistory } from "react-router-dom";
import AntModal from "../AntModal";
import EditorStemsEmblem from "../EditorStemsEmblem";
import { Button } from "../Buttons/Button";
import { Title, BulletList, Bullet, EditorPromo, StemsWrap, Actions } from "./styles";

/**
 * One-time modal shown right after a user creates a free account.
 * Pitches a 30-day subscription trial. The `?trial=true` param tells the
 * checkout flow to request a Stripe free trial (applied server-side for
 * first-time subscribers).
 *
 * Triggered by a `show-signup-promo` localStorage flag set on signup.
 */
const SignupPromoModal = ({ open, onClose }) => {
  const history = useHistory();

  const handleStartTrial = () => {
    onClose();
    history.push(`/subscription?trial=true`);
  };

  return (
    <AntModal modalState={{ visible: open, close: onClose }} width={520}>
      <Title>
        Try Blue Dot Sessions <span className="accent">free for 30 days</span>
      </Title>
      <BulletList>
        <Bullet>
          Subscribers get full access to 10,000+ tracks, multitrack stems and
          variations
        </Bullet>
        <Bullet>
          Full quality 24bit .wav files ready to drop into your project
        </Bullet>
        <Bullet>Access to the Multitrack Editor across the whole library</Bullet>
      </BulletList>

      <EditorPromo>
        <div className="title">
          Multitrack Editor<span className="new">NEW</span>
        </div>
        <p>
          Make quick edits to the track from the stem files and download your
          high-quality Custom Mix.
        </p>
        <StemsWrap>
          <EditorStemsEmblem />
        </StemsWrap>
      </EditorPromo>

      <Actions>
        <button type="button" className="link" onClick={onClose}>
          No, thanks
        </button>
        <Button subscribe px={24} py={12} onClick={handleStartTrial}>
          Start your trial today
        </Button>
      </Actions>
    </AntModal>
  );
};

export default SignupPromoModal;
